import { render, staticRenderFns } from "./EvalCompetencies.vue?vue&type=template&id=d5d5b148&scoped=true"
import script from "./EvalCompetencies.vue?vue&type=script&lang=js"
export * from "./EvalCompetencies.vue?vue&type=script&lang=js"
import style0 from "./EvalCompetencies.vue?vue&type=style&index=0&id=d5d5b148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d5b148",
  null
  
)

export default component.exports